function isObject(value: any): value is {
  value: string;
  label: React.ReactNode;
} {
  return value && typeof value === "object" && value.constructor === Object;
}

export default isObject;
